module.exports = __webpack_public_path__ + "img/socialise.9317ba68.jpg";